module.exports = "/_next/static/images/success-plus-graph-10aa6a53b192cfe192e1530f58772e5d.png";